import { useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { OrderTransport } from "src/app/transports/order";

export interface IAddBoostToOrderModelContainer {
    selectedRows: Array<TSelectedRows>;
    handlerValueToUpdateGrid(update: boolean): void;
    handleClose(): void;
    showModal: boolean;
}
interface ISelectedRows {
    id: number;
    keyword?: string;
    keywords?: string[];
    url: string;
}

export type TSelectedRows =
    | (ISelectedRows & { keyword: string; keywords?: never })
    | (ISelectedRows & { keyword?: never; keywords: string[] });

const AddBoostToFavoriteModalContainer = (props: IAddBoostToOrderModelContainer) => {
    const { selectedRows, handlerValueToUpdateGrid, handleClose, showModal } = props;

    const { formatMessage } = useIntl();

    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        setLoading(true);

        try {
            await OrderTransport.addBoostToFavorite(selectedRows.map((el) => el.id));
            toast.success(formatMessage({ id: "common.notification.success" }));
            handlerValueToUpdateGrid(true);
            handleClose();
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.favorite" })}
            showModal={showModal}
            handleClose={handleClose}
            buttonConfirmationAction={onSubmit}
            buttonConfirmationLabel={formatMessage({ id: "common.action.confirmation" })}
            formId=""
            loading={loading}
            modalProps={{ size: "xl" }}
        >
            <>
                <Form.Label>
                    {formatMessage({ id: "common.field.changeModalType.label" })}
                </Form.Label>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Keyword</th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedRows.map((el, index) => {
                            return (
                                <tr key={index}>
                                    <td>{el.keyword || "n/d"}</td>
                                    <td>
                                        <a href={el.url} target="_blank">
                                            {el.url}
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </>
        </SimpleModal>
    );
};

export default AddBoostToFavoriteModalContainer;
